<template >
    <div>
        <md-field>
            <label>Title</label>
            <md-textarea
                    md-autogrow
                    maxlength="100"
                    v-model="headline"
                    @keyup="$emit('update:headline', headline);"
            ></md-textarea>
            <span class="md-helper-text">Explain why you need this loan in 100 characters or less. Make it catchy — this is the first thing lenders see!</span>
        </md-field>
        <br><br>
        <b-collapse :open="false" aria-id="contentIdForA11y3">
            <div slot="trigger" slot-scope="props" role="button" aria-controls="contentIdForA11y3">
                <span class="is-size-7 has-text-grey-light">Optional</span>
                <p class="has-text-grey is-size-7">+ Expound more</p>
            </div>
            <div>
                <md-field>
                    <label>Write a bit more</label>
                    <md-textarea
                            md-autogrow
                            v-model="body"
                            @keyup="$emit('update:body', body);"
                    ></md-textarea>
                    <span class="md-helper-text">Use this space to expound on the purpose of this loan</span>
                </md-field>
            </div>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name: "post-text",
        props: ['headline','body']
    }
</script>

<style scoped>

</style>